import { useNavigate, useParams } from "react-router-dom";
import { getLocalStorageData } from "../../utils/LocalStorageService";
import { useDispatch } from "react-redux";
import { useEffect, useState } from "react";
import { ACTION_TYPE, REPORT_NAME, REPORT_PATH } from "../../components/constant/reportType";
import { Descriptions, Radio, RadioChangeEvent, Switch, Table } from "antd";
import { AGENT_MASTER_COLUMN, ORGANIZATION_MASTER_COLUMN, RESPONSIBILITY_CENTER_COLUMN, RESPONSIBILITY_GROUP_COLUMN, TOKEN_MECHANISM_MASTER_COLUMN, VALUE_CHAIN_CATEGORY_COLUMN, VALUE_CHAIN_COLUMN } from "../../components/constant/AppConstant";
import { BsPencilSquare, BsPlus, BsSearch } from "react-icons/bs";
import { alertMessage } from "../../utils/AlertService";
import MasterReportData from "./MasterReportData";
import { useAppSelector } from "../../redux-toolkit/hooks";
import Loading from "../Loading";
import { useDeleteValueChainByIdMutation, useGetAllValueChainsWithPaginationMutation, useGetAllValueChainsWithSearchMutation } from "../../redux-toolkit/services/allValueChainsService";
import { useDeleteValueChainCategoryByIdMutation, useGetAllValueChainCategoryWithPaginationMutation, useGetAllValueChainCategoriesWithSearchMutation } from "../../redux-toolkit/services/allValueChainCategoriesService";
import { getAllValueChainCategoriesBySearchDetails, getAllValueChainCategoriesDetails, getValueChainCategoriesTotalRecords, setAllValueChainCategories, setAllValueChainCategoriesBySearch } from "../../redux-toolkit/slices/allValueChainCategorySlice";
import { getAllValueChainsDetails, getAllValueChainsDetailsBySearch, getValueChainTotalRecords, setAllValueChains, setAllValueChainsBySearch } from "../../redux-toolkit/slices/allValueChainsSlice";
import { useDeleteAgentMasterByIdMutation, useGetAllAgentMasterWithPaginationMutation, useGetAllAgentMasterWithSearchMutation } from "../../redux-toolkit/services/allAgentMasterService";
import { getAgentMasterDetails, getAgentMasterDetailsBySearch, getAgentMasterTotalRecords, setAgentMaster, setAgentMasterBySearch, setAllAgentMaster } from "../../redux-toolkit/slices/allAgentMasterSlice";
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import { useDeleteResponsibilityCenterByIdMutation, useGetAllResponsibilityCentersMutation, useGetAllResponsibilityCentersWithSearchMutation } from "../../redux-toolkit/services/responsibilityCenterService";
import { useDeleteResponsibilityGroupByIdMutation, useGetAllResponsibilityGroupsMutation, useGetAllResponsibilityGroupsWithSearchMutation } from "../../redux-toolkit/services/responsibilityGroupService";
import { getAllResponsibilityGroupBySearch, getAllResponsibilityGroupDetails, getResponsibilityGroupTotalRecords, setAllResponsibilityGroup, setAllResponsibilityGroupBySearch } from "../../redux-toolkit/slices/responsibilityGroupSlice";
import { getAllResponsibilityCenterBySearch, getAllResponsibilityCenterDetails, getResponsibilityCenterTotalRecords, setAllResponsibilityCenter, setAllResponsibilityCenterBySearch } from "../../redux-toolkit/slices/responsibilityCenterSlice";
import { useDeleteOrganizationMasterMutation, useGetAllOrganizationMasterBySearchMutation, useGetAllOrganizationMasterMutation } from "../../redux-toolkit/services/organizationMasterService";
import { allOrganizationMasterDetails, getAllOrganizationMasterBySearch, getOrganizationMasterTotalRecords, setAllOrganizationMasterBySearch, setOrganizationMaster } from "../../redux-toolkit/slices/organizationMasterSlice";
import { useDeleteTokenMechanismMasterMutation, useGetAllTokenMechanismMasterWithPaginationMutation, useSearchTokenMechanismMastersMutation } from "../../redux-toolkit/services/tokenMechanismMasterService";
import { getTokenMechanismMasterData, getTokenMechanismMasterDataBySearch, getTokenMechanismMasterTotalRecords, setTokenMechanismMasters, setTokenMechanismMastersBySearch } from "../../redux-toolkit/slices/tokenMechanismMasterSlice";
import { useSaveAuditLogMutation } from "../../redux-toolkit/services/auditLogService";

type Props = {};
const DataSourceMangement = (props: Props) => {

    const params = useParams();
    const dispatch = useDispatch();
    const localUserObj: any = getLocalStorageData("localUser");
    const token: any = getLocalStorageData("localUser").token;

    //state
    const [actionType, setActionType] = useState(ACTION_TYPE.ADD_ACTION) as any;
    const [reportName, setReportName]: any = useState();
    const [currentpage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [show, setShow] = useState(false);
    const [selectedRow, setSelectedRow]: any = useState([]);
    const [columData, setColumnData]: any = useState();
    const [dataSource, setDatasource]: any = useState([]);
    const [call, setCall] = useState("N");
    console.log(call, "call");
    const [isCategory, setIsCategory] = useState(false);

    //getMutations
    const [getAllAgentMasterWithPagination, allAgentMasterResponseWithPagination] = useGetAllAgentMasterWithPaginationMutation();
    const [getAllValueChains, valueChainsResponse] = useGetAllValueChainsWithPaginationMutation();
    const [getAllValueChainCategoriesWithPagination, valueChainCategoriesWithPaginationResponse] = useGetAllValueChainCategoryWithPaginationMutation();
    const [getAllResponsibilityCenters, responsibilityCenterResponse] = useGetAllResponsibilityCentersMutation();
    const [getAllResponsibilityGroups, responsibilityGroupResponse] = useGetAllResponsibilityGroupsMutation();
    const [getAllOrganizationMaster, allOrganizationMasterResponse] = useGetAllOrganizationMasterMutation();
    const [getAllTokenMechanismMaster, allTokenMechanismMasterResponse] = useGetAllTokenMechanismMasterWithPaginationMutation();
    //search
    const [getAllAgentMasterWithSearch, allAgentMasterWithSearchResponse] = useGetAllAgentMasterWithSearchMutation();
    const [getAllResponsibilityCentersWithSearch, allResponsibilityCentersWithSearchResponse] = useGetAllResponsibilityCentersWithSearchMutation();
    const [getAllResponsibilityGroupsWithSearch, allResponsibilityGroupsWithSearchResponse] = useGetAllResponsibilityGroupsWithSearchMutation();
    const [getAllValueChainWithSearch, getAllValueChainWithSearchResponse] = useGetAllValueChainsWithSearchMutation();
    const [getAllValueChainCategoryWithSearch, getAllValueChainCategoryWithSearchResponse] = useGetAllValueChainCategoriesWithSearchMutation();
    const [getAllTokenMechanismMasterWithSearch, getAllTokenMechanismMasterWithSearchResponse] = useSearchTokenMechanismMastersMutation();

    //save
    const [logAudit] = useSaveAuditLogMutation();

    //delete mutation
    const [deleteAgentMasterById, deleteAgentMasterByIdResponse] = useDeleteAgentMasterByIdMutation();
    const [deleteValueChainById, deleteValueChainByIdResponse] = useDeleteValueChainByIdMutation();
    const [deleteResponsibilityCenter, deleteResponsibilityCenterResponse] = useDeleteResponsibilityCenterByIdMutation();
    const [deleteResponsibilityGroup, deleteResponsibilityGroupResponse] = useDeleteResponsibilityGroupByIdMutation();
    const [deleteValueChainCategoryById, deleteValueChainCategoryByIdResponse] = useDeleteValueChainCategoryByIdMutation();
    const [deleteOrganizationMaster, deleteOrganizationMasterResponse] = useDeleteOrganizationMasterMutation();
    const [deleteTokenMechanismMaster, deleteTokenMechanismMasterResponse] = useDeleteTokenMechanismMasterMutation();

    //totalRecords
    const totalAgentMaster: any = useAppSelector(getAgentMasterTotalRecords);
    const totalValueChainCategory: any = useAppSelector(getValueChainCategoriesTotalRecords);
    const totalValueChain: any = useAppSelector(getValueChainTotalRecords);
    const totalResponsibilityCenters: any = useAppSelector(getResponsibilityCenterTotalRecords);
    const totalResponsibilityGroups: any = useAppSelector(getResponsibilityGroupTotalRecords);
    const totalOrganizationMaster: any = useAppSelector(getOrganizationMasterTotalRecords);
    const totalTokenMechanismMaster: any = useAppSelector(getTokenMechanismMasterTotalRecords);
    //selector
    const allAgentMasterWithPagination: any = useAppSelector(getAgentMasterDetails)
    const allAgentMasterBySearch: any = useAppSelector(getAgentMasterDetailsBySearch);
    const allValueChains: any = useAppSelector(getAllValueChainsDetails);
    const allValueChainsBySearch: any = useAppSelector(getAllValueChainsDetailsBySearch);
    const allValueChainCategories: any = useAppSelector(getAllValueChainCategoriesDetails);
    const allValueChainCategoriesBySearch: any = useAppSelector(getAllValueChainCategoriesBySearchDetails);
    const allResponsibilityCenters: any = useAppSelector(getAllResponsibilityCenterDetails);
    const allResponsibilityCentersBySearch: any = useAppSelector(getAllResponsibilityCenterBySearch);
    const allResponsibilityGroups: any = useAppSelector(getAllResponsibilityGroupDetails);
    const allResponsibilityGroupsBySearch: any = useAppSelector(getAllResponsibilityGroupBySearch);
    const allOrganizationMaster: any = useAppSelector(allOrganizationMasterDetails);
    const allOrganizationMasterBySearch: any = useAppSelector(getAllOrganizationMasterBySearch);
    const allTokenMechanismMasterBySearch: any = useAppSelector(getTokenMechanismMasterDataBySearch);
    const allTokenMechanismMaster: any = useAppSelector(getTokenMechanismMasterData);

    useEffect(() => {
        switch (params.reportType) {
            case REPORT_PATH.AGENT_MASTER:
                setReportName(REPORT_NAME.AGENT_MASTER)
                break;
            case REPORT_PATH.VALUE_CHAIN_CATEGORY:
                setReportName(REPORT_NAME.VALUE_CHAIN_CATEGORY)
                break;
            case REPORT_PATH.VALUE_CHAIN:
                setReportName(REPORT_NAME.VALUE_CHAIN)
                break;
            case REPORT_PATH.RESPONSIBILITY_GROUP:
                setReportName(REPORT_NAME.RESPONSIBILITY_GROUP)
                break;
            case REPORT_PATH.RESPONSIBILITY_CENTER:
                setReportName(REPORT_NAME.RESPONSIBILITY_CENTER)
                break;
            case REPORT_PATH.ORGANIZATION_MASTER:
                setReportName(REPORT_NAME.ORGANIZATION_MASTER)
                break;
            case REPORT_PATH.TOKEN_MECHANISM_MASTER:
                setReportName(REPORT_NAME.TOKEN_MECHANISM_MASTER)
                break;
            default:
        }
    }, [params.reportType]);

    useEffect(() => {
        const temp: any = [];
        const tempAction: any = {
            title: "Action",
            dataIndex: "action",
            key: "name",
            fixed: "right",
            width: 120,
            render: (index: any, record: any) => {
                return (
                    // for delete switch button
                    <div className="d-flex justify-content-between">
                        <div className="px-2 pe-auto">
                            <Switch
                                className={`${record.status === true ||
                                    record.enabled === true ||
                                    record.isActive === true ? "bg-accent" : "bg-secondry"}`}
                                checked={
                                    record.status === true ||
                                        record.enabled === true ||
                                        record.isActive === true
                                        ? true
                                        : false
                                }
                                onClick={() => {
                                    console.log(record, "record")
                                    onDeleteData(record);
                                }}
                            />
                        </div>
                        {record.status === true ||
                            record.enabled === true ||
                            record.isActive === true ? (
                            <div
                                className="px-2 pe-auto"
                                onClick={() => {
                                    handleOpenForm(record);
                                }}
                            >
                                <BsPencilSquare size={18} />
                            </div>
                        ) : null}
                    </div>
                );
            },
        };

        if (reportName === REPORT_NAME.AGENT_MASTER && AGENT_MASTER_COLUMN) {
            AGENT_MASTER_COLUMN.map((item: any) => {
                temp.push(item);
            });
            temp.push(tempAction);
            setColumnData(temp);
        } else if (reportName === REPORT_NAME.VALUE_CHAIN_CATEGORY && VALUE_CHAIN_CATEGORY_COLUMN) {
            VALUE_CHAIN_CATEGORY_COLUMN.map((item: any) => {
                temp.push(item);
            });
            temp.push(tempAction);
            setColumnData(temp);
        } else if (reportName === REPORT_NAME.VALUE_CHAIN && VALUE_CHAIN_COLUMN) {
            VALUE_CHAIN_COLUMN.map((item: any) => {
                temp.push(item);
            });
            temp.push(tempAction);
            setColumnData(temp);
        } else if (reportName === REPORT_NAME.RESPONSIBILITY_CENTER && RESPONSIBILITY_CENTER_COLUMN) {
            RESPONSIBILITY_CENTER_COLUMN.map((item: any) => {
                temp.push(item);
            });
            temp.push(tempAction);
            setColumnData(temp);
        } else if (reportName === REPORT_NAME.RESPONSIBILITY_GROUP && RESPONSIBILITY_GROUP_COLUMN) {
            RESPONSIBILITY_GROUP_COLUMN.map((item: any) => {
                temp.push(item);
            });
            temp.push(tempAction);
            setColumnData(temp);
        } else if (reportName === REPORT_NAME.ORGANIZATION_MASTER && ORGANIZATION_MASTER_COLUMN) {
            ORGANIZATION_MASTER_COLUMN.map((item: any) => {
                temp.push(item);
            });
            temp.push(tempAction);
            setColumnData(temp);
        }
        else if (reportName === REPORT_NAME.TOKEN_MECHANISM_MASTER && TOKEN_MECHANISM_MASTER_COLUMN) {
            TOKEN_MECHANISM_MASTER_COLUMN.map((item: any) => {
                temp.push(item);
            });
            temp.push(tempAction);
            setColumnData(temp);
        }
    }, [reportName, params.reportType]);

    useEffect(() => {
        if (reportName === REPORT_NAME.AGENT_MASTER) {
            getAllAgentMasterWithPagination({
                token: localUserObj?.token,
                page: currentpage - 1,
                size: pageSize,
                sort: "id",
            });
        } else if (reportName === REPORT_NAME.VALUE_CHAIN_CATEGORY) {
            setIsCategory(true);
            getAllValueChainCategoriesWithPagination({
                token: localUserObj?.token,
                page: currentpage - 1,
                size: pageSize,
                sort: "id",
            });
        } else if (reportName === REPORT_NAME.VALUE_CHAIN) {
            setIsCategory(false);
            getAllValueChains({ token: localUserObj?.token, page: currentpage - 1, size: pageSize, sort: "id" });
        } else if (reportName === REPORT_NAME.RESPONSIBILITY_CENTER) {
            setIsCategory(false);
            getAllResponsibilityCenters({
                token: localUserObj?.token,
                payload: {
                    searchBy: "",
                    offset: pageSize,
                    pageNumber: currentpage - 1,
                    sortDir: "asc"
                }
            });
        } else if (reportName === REPORT_NAME.RESPONSIBILITY_GROUP) {
            setIsCategory(true);
            getAllResponsibilityGroups({
                token: localUserObj?.token,
                payload: {
                    searchBy: "",
                    offset: pageSize,
                    pageNumber: currentpage - 1,
                    sortDir: "asc"
                }
            });
        } else if (reportName === REPORT_NAME.ORGANIZATION_MASTER) {
            setIsCategory(true);
            getAllOrganizationMaster({
                token: localUserObj?.token,
                payload: {
                    page: currentpage - 1,
                    size: pageSize,
                    orderBy: "desc",
                }
            });
        }
        else if (reportName === REPORT_NAME.TOKEN_MECHANISM_MASTER) {
            getAllTokenMechanismMaster({
                token: localUserObj?.token,
                payload: {
                    page: currentpage - 1,
                    offset: pageSize,
                    orderBy: "desc",
                }
            });
        }
    }, [reportName]);

    useEffect(() => {
        console.log(reportName === REPORT_NAME.TOKEN_MECHANISM_MASTER, "reportName1");

        if (call === "Y") {
            console.log(reportName === REPORT_NAME.TOKEN_MECHANISM_MASTER, "reportName2");

            if (reportName === REPORT_NAME.AGENT_MASTER) {
                getAllAgentMasterWithPagination({
                    token: localUserObj?.token,
                    page: currentpage - 1,
                    size: pageSize,
                    sort: "id",
                });
                setCall("N");
            } else if (reportName === REPORT_NAME.VALUE_CHAIN_CATEGORY) {
                setIsCategory(true);
                getAllValueChainCategoriesWithPagination({
                    token: localUserObj?.token,
                    page: currentpage - 1,
                    size: pageSize,
                    sort: "id",
                });
                setCall("N");
            } else if (reportName === REPORT_NAME.VALUE_CHAIN) {
                setIsCategory(false);
                getAllValueChains({
                    token: localUserObj?.token,
                    page: currentpage - 1,
                    size: pageSize,
                    sort: "id",
                });
                setCall("N");
            } else if (reportName === REPORT_NAME.RESPONSIBILITY_CENTER) {
                setIsCategory(false);
                getAllResponsibilityCenters({
                    token: localUserObj?.token,
                    payload: {
                        searchBy: "",
                        offset: pageSize,
                        pageNumber: currentpage - 1,
                        sortDir: "asc"
                    }
                });
                setCall("N");
            } else if (reportName === REPORT_NAME.RESPONSIBILITY_GROUP) {
                setIsCategory(true);
                getAllResponsibilityGroups({
                    token: localUserObj?.token,
                    payload: {
                        searchBy: "",
                        offset: pageSize,
                        pageNumber: currentpage - 1,
                        sortDir: "asc"
                    }
                });
                setCall("N");
            } else if (reportName === REPORT_NAME.ORGANIZATION_MASTER) {
                setIsCategory(true);
                getAllOrganizationMaster({
                    token: localUserObj?.token,
                    payload: {
                        searchBy: "",
                        offset: pageSize,
                        pageNumber: currentpage - 1,
                        sortDir: "asc"
                    }
                });
                setCall("N");
            }
            else if (reportName === REPORT_NAME.TOKEN_MECHANISM_MASTER) {
                console.log(reportName === REPORT_NAME.TOKEN_MECHANISM_MASTER, "reportName3");
                getAllTokenMechanismMaster({
                    token: localUserObj?.token,
                    payload: {
                        searchBy: "",
                        offset: pageSize,
                        page: currentpage - 1,
                        orderBy: "asc"
                    }
                });
                setCall("N");
            }
        }
    }, [call]);

    const paginationChange = (page: number, pageSize: number) => {
        if (reportName === REPORT_NAME.AGENT_MASTER) {
            getAllAgentMasterWithPagination({
                token: localUserObj?.token,
                page: page - 1,
                size: pageSize,
                sort: "id",
            });
        } else if (reportName === REPORT_NAME.VALUE_CHAIN_CATEGORY) {
            getAllValueChainCategoriesWithPagination({
                token: localUserObj?.token,
                page: page - 1,
                size: pageSize,
                sort: "id",
            });
        } else if (reportName === REPORT_NAME.VALUE_CHAIN_CATEGORY) {
            getAllValueChainCategoriesWithPagination({
                token: localUserObj?.token,
                page: page - 1,
                size: pageSize,
                sort: "id",
            });
        } else if (reportName === REPORT_NAME.VALUE_CHAIN) {
            getAllValueChains({
                token: localUserObj?.token,
                page: page - 1,
                size: pageSize,
                sort: "id",
            });
        } else if (reportName === REPORT_NAME.RESPONSIBILITY_CENTER) {
            getAllResponsibilityCenters({
                token: localUserObj?.token,
                payload: {
                    searchBy: "",
                    offset: pageSize,
                    pageNumber: currentpage - 1,
                    sortDir: "asc"
                }
            });
        } else if (reportName === REPORT_NAME.RESPONSIBILITY_GROUP) {
            getAllResponsibilityGroups({
                token: localUserObj?.token,
                payload: {
                    searchBy: "",
                    offset: pageSize,
                    pageNumber: currentpage - 1,
                    sortDir: "asc"
                }
            });
        } else if (reportName === REPORT_NAME.ORGANIZATION_MASTER) {
            getAllOrganizationMaster({
                token: localUserObj?.token,
                payload: {
                    searchBy: "",
                    offset: pageSize,
                    pageNumber: currentpage - 1,
                    sortDir: "asc"
                }
            });
        }
        else if (reportName === REPORT_NAME.TOKEN_MECHANISM_MASTER) {
            getAllTokenMechanismMaster({
                token: localUserObj?.token,
                payload: {
                    searchBy: "",
                    offset: pageSize,
                    page: currentpage - 1,
                    orderBy: "asc"
                }
            });
        }
        setCurrentPage(page);
        setPageSize(pageSize);
    };

    const handleShow = () => {
        setActionType(ACTION_TYPE.ADD_ACTION);
        setShow(true)
    };

    const onDeleteData = (record: any) => {
        if (reportName === REPORT_NAME.AGENT_MASTER) {
            deleteAgentMasterById({ token: localUserObj?.token, id: record.id });

            const payload = {
                tableName: REPORT_NAME.AGENT_MASTER,
                recordId: record.id,
                operationType: "DELETE",
                oldValue: record,
                newValue: { ...record, isActive: !record.isActive },
            };
            logAudit({ token: localUserObj?.token, payload });

        } else if (reportName === REPORT_NAME.VALUE_CHAIN_CATEGORY) {
            deleteValueChainCategoryById({ token: localUserObj?.token, id: record.id });

            const payload = {
                tableName: REPORT_NAME.VALUE_CHAIN_CATEGORY,
                recordId: record.id,
                operationType: "DELETE",
                oldValue: record,
                newValue: { ...record, isActive: !record.isActive },
            };
            logAudit({ token: localUserObj?.token, payload });

        } else if (reportName === REPORT_NAME.VALUE_CHAIN) {
            deleteValueChainById({ token: localUserObj?.token, id: record.id });

            const payload = {
                tableName: REPORT_NAME.VALUE_CHAIN,
                recordId: record.id,
                operationType: "DELETE",
                oldValue: record,
                newValue: { ...record, isActive: !record.isActive },
            };
            logAudit({ token: localUserObj?.token, payload });

        } else if (reportName === REPORT_NAME.RESPONSIBILITY_CENTER) {
            deleteResponsibilityCenter({ token: localUserObj?.token, id: record.id });

            const payload = {
                tableName: REPORT_NAME.RESPONSIBILITY_CENTER,
                recordId: record.id,
                operationType: "DELETE",
                oldValue: record,
                newValue: { ...record, isActive: !record.isActive },
            };
            logAudit({ token: localUserObj?.token, payload });

        } else if (reportName === REPORT_NAME.RESPONSIBILITY_GROUP) {
            deleteResponsibilityGroup({ token: localUserObj?.token, id: record.id });

            const payload = {
                tableName: REPORT_NAME.RESPONSIBILITY_GROUP,
                recordId: record.id,
                operationType: "DELETE",
                oldValue: record,
                newValue: { ...record, isActive: !record.isActive },
            };
            logAudit({ token: localUserObj?.token, payload });

        } else if (reportName === REPORT_NAME.ORGANIZATION_MASTER) {
            deleteOrganizationMaster({
                id: record.id,
                token: localUserObj?.token,
            });

            const payload = {
                tableName: REPORT_NAME.ORGANIZATION_MASTER,
                recordId: record.id,
                operationType: "DELETE",
                oldValue: record,
                newValue: { ...record, isActive: !record.isActive },
            };
            logAudit({ token: localUserObj?.token, payload });

        } else if (reportName === REPORT_NAME.TOKEN_MECHANISM_MASTER) {
            console.log(record, "record");
            deleteTokenMechanismMaster({
                id: record.id,
                token: localUserObj?.token,
            });

            const payload = {
                tableName: REPORT_NAME.TOKEN_MECHANISM_MASTER,
                recordId: record.id,
                operationType: "DELETE",
                oldValue: record,
                newValue: { ...record, isActive: !record.isActive },
            };
            logAudit({ token: localUserObj?.token, payload });
        }
    };


    useEffect(() => {
        if (deleteAgentMasterByIdResponse.isSuccess) {
            if (deleteAgentMasterByIdResponse.data?.isActive) {
                alertMessage("Agent Master enable successfully", "success");
            } else {
                alertMessage("Agent Master deleted successfully", "success");
            }
            setCall("Y");
        } else if (deleteAgentMasterByIdResponse.isError) {
            alertMessage("Error while deleting", "error");
        }
    }, [deleteAgentMasterByIdResponse.isSuccess, deleteAgentMasterByIdResponse.isError]);

    useEffect(() => {
        if (deleteOrganizationMasterResponse.isSuccess) {
            if (deleteOrganizationMasterResponse.data?.isActive) {
                alertMessage("Organization Master enable successfully", "success");
            } else {
                alertMessage("Organization Master deleted successfully", "success");
            }
            setCall("Y");
        } else if (deleteOrganizationMasterResponse.isError) {
            alertMessage("Error while deleting", "error");
        }
    }, [deleteOrganizationMasterResponse.isSuccess, deleteOrganizationMasterResponse.isError]);

    useEffect(() => {
        if (deleteValueChainCategoryByIdResponse.isSuccess) {
            if (deleteValueChainCategoryByIdResponse.data?.isActive) {
                alertMessage("Value Chain Category enable successfully", "success");
            } else {
                alertMessage("Value Chain Category deleted successfully", "success");
            }
            setCall("Y");
        } else if (deleteValueChainCategoryByIdResponse.isError) {
            alertMessage("Error while deleting", "error");
        }
    }, [deleteValueChainCategoryByIdResponse.isSuccess, deleteValueChainCategoryByIdResponse.isError]);

    useEffect(() => {
        if (deleteValueChainByIdResponse.isSuccess) {
            if (deleteValueChainByIdResponse.data?.isActive) {
                alertMessage("Value Chain enable successfully", "success");
            } else {
                alertMessage("Value Chain deleted successfully", "success");
            }
            setCall("Y");
        } else if (deleteValueChainByIdResponse.isError) {
            alertMessage("Error while deleting", "error");
        }
    }, [deleteValueChainByIdResponse.isSuccess, deleteValueChainByIdResponse.isError,]);

    useEffect(() => {
        if (deleteResponsibilityGroupResponse.isSuccess) {
            if (deleteResponsibilityGroupResponse.data?.isActive) {
                alertMessage("Responsibility Group enable successfully", "success");
            } else {
                alertMessage("Responsibility Group deleted successfully", "success");
            }
            setCall("Y");
        } else if (deleteResponsibilityGroupResponse.isError) {
            alertMessage("Error while deleting", "error");
        }
    }, [deleteResponsibilityGroupResponse.isSuccess, deleteResponsibilityGroupResponse.isError]);

    useEffect(() => {
        if (deleteResponsibilityCenterResponse.isSuccess) {
            if (deleteResponsibilityCenterResponse.data?.isActive) {
                alertMessage("Responsibility Center enable successfully", "success");
            } else {
                alertMessage("Responsibility Center deleted successfully", "success");
            }
            setCall("Y");
        } else if (deleteResponsibilityCenterResponse.isError) {
            alertMessage("Error while deleting", "error");
        }
    }, [deleteResponsibilityCenterResponse.isSuccess, deleteResponsibilityCenterResponse.isError]);


    useEffect(() => {
        if (deleteTokenMechanismMasterResponse.isSuccess) {
            if (deleteTokenMechanismMasterResponse.data?.isActive) {
                alertMessage("Token Mechanism Master enabled successfully", "success");
            } else {
                alertMessage("Token Mechanism Master deleted successfully", "success");
            }
            setCall("Y");
        } else if (deleteTokenMechanismMasterResponse.isError) {
            alertMessage("Error while deleting Token Mechanism Master", "error");
        }
    }, [deleteTokenMechanismMasterResponse.isSuccess, deleteTokenMechanismMasterResponse.isError]);


    const handleOpenForm = (record: any) => {
        setActionType(ACTION_TYPE.UPDATE_ACTION);
        setSelectedRow(record);
        setShow(true);
    };

    useEffect(() => {
        if (allAgentMasterResponseWithPagination.isSuccess) {
            dispatch(setAgentMaster(allAgentMasterResponseWithPagination));
        } else if (allAgentMasterResponseWithPagination.isError) {
            let response: any = allAgentMasterResponseWithPagination.error;
            alertMessage(response, "error");
        }

    }, [allAgentMasterResponseWithPagination.isSuccess, allAgentMasterResponseWithPagination.isError]);

    useEffect(() => {
        if (allOrganizationMasterResponse.isSuccess) {
            dispatch(setOrganizationMaster(allOrganizationMasterResponse));
        } else if (allOrganizationMasterResponse.isError) {
            let response: any = allOrganizationMasterResponse.error;
            alertMessage(response, "error");
        }
    }, [allOrganizationMasterResponse.isSuccess, allOrganizationMasterResponse.isError]);

    useEffect(() => {
        if (valueChainCategoriesWithPaginationResponse.isSuccess) {
            dispatch(setAllValueChainCategories(valueChainCategoriesWithPaginationResponse));
        } else if (valueChainCategoriesWithPaginationResponse.isError) {
            let response: any = valueChainCategoriesWithPaginationResponse.error;
            alertMessage(response, "error");
        }
    }, [valueChainCategoriesWithPaginationResponse.isSuccess, valueChainCategoriesWithPaginationResponse.isError]);

    useEffect(() => {
        if (valueChainsResponse.isSuccess) {
            dispatch(setAllValueChains(valueChainsResponse));
        } else if (valueChainsResponse.isError) {
            let response: any = valueChainsResponse.error;
            alertMessage(response, "error");
        }
    }, [valueChainsResponse.isSuccess, valueChainsResponse.isError]);

    useEffect(() => {
        if (responsibilityGroupResponse.isSuccess) {
            dispatch(setAllResponsibilityGroup(responsibilityGroupResponse));
        } else if (responsibilityGroupResponse.isError) {
            alertMessage("Error while fetching data", "error");
        }
    }, [responsibilityGroupResponse.isSuccess, responsibilityGroupResponse.isError]);

    useEffect(() => {
        if (responsibilityCenterResponse.isSuccess) {
            dispatch(setAllResponsibilityCenter(responsibilityCenterResponse));
        } else if (responsibilityCenterResponse.isError) {
            alertMessage("Error while fetching data", "error");
        }
    }, [responsibilityCenterResponse.isSuccess, responsibilityCenterResponse.isError]);


    useEffect(() => {
        if (allTokenMechanismMasterResponse.isSuccess) {
            dispatch(setTokenMechanismMasters(allTokenMechanismMasterResponse));
        } else if (allTokenMechanismMasterResponse.isError) {
            alertMessage("Error while fetching data", "error");
        }
    }, [allTokenMechanismMasterResponse.isSuccess, allTokenMechanismMasterResponse.isError]);

    const buildValueChainDataSource = (data: any) => {
        let temp: any = [];
        data.forEach((element: any) => {
            // let payload =
            temp.push({
                id: element.id,
                categoryName: element?.valueChainCategoryObj ? element?.valueChainCategoryObj?.categoryName : "-",
                name: element.valueChainName,
                parameters: element.parameters,
                dependentValueChainCode: element.dependentValueChainCode,
                isActive: element.isActive,
            });
        });
        setDatasource(temp);
    };

    const buildValueChainCategoryDataSource = (data: any) => {
        let temp: any = [];
        data.forEach((element: any) => {
            // let payload =
            temp.push({
                id: element.id,
                name: element.categoryName,
                description: element.description,
                dependentValueChainCategoryCode: element.dependentValueChainCategoryCode,
                isActive: element.isActive,
            });
        });
        setDatasource(temp);
    };

    const buildResponsibilityCentersDatasource = (data: any) => {
        let temp: any = [];
        data.forEach((element: any) => {
            // let payload =
            temp.push({
                id: element?.id,
                groupName: element?.responsibilityGroupObj ? element?.responsibilityGroupObj?.groupName : "-",
                name: element?.resCenterName,
                description: element?.resCenterDesc,
                dependentRespCenterCode: element?.dependentRespCenterCode,
                isActive: element?.isActive,
            });
        });
        setDatasource(temp);
    };

    //data

    useEffect(() => {
        if (allAgentMasterWithPagination && reportName === REPORT_NAME.AGENT_MASTER) {
            setDatasource(allAgentMasterWithPagination);
        }
    }, [allAgentMasterWithPagination]);

    useEffect(() => {
        if (allOrganizationMaster && reportName === REPORT_NAME.ORGANIZATION_MASTER) {
            setDatasource(allOrganizationMaster);
        }
    }, [allOrganizationMaster]);

    useEffect(() => {
        if (allTokenMechanismMaster && reportName === REPORT_NAME.TOKEN_MECHANISM_MASTER) {
            buildTokenMechanismMasterDataSource(allTokenMechanismMaster);
        }
    }, [allTokenMechanismMaster]);

    const buildTokenMechanismMasterDataSource = (data: any) => {
        let temp: any = [];
        data.forEach((element: any) => {
            temp.push({
                id: element.id,
                description: element.description,
                effectiveFromDate: element.effectiveFromDate,
                effectiveToDate: element.effectiveToDate,
                multiplier: element.multiplier,
                currencyUnit: element.currencyUnit,
                isActive: element.isActive,
            });
        });
        setDatasource(temp);
    };



    useEffect(() => {
        if (allValueChains && reportName === REPORT_NAME.VALUE_CHAIN) {
            buildValueChainDataSource(allValueChains)
        }
    }, [allValueChains]);

    useEffect(() => {
        if (allValueChainCategories && reportName === REPORT_NAME.VALUE_CHAIN_CATEGORY) {
            buildValueChainCategoryDataSource(allValueChainCategories);
        }
    }, [allValueChainCategories]);

    useEffect(() => {
        if (allResponsibilityGroups && reportName === REPORT_NAME.RESPONSIBILITY_GROUP) {
            setDatasource(allResponsibilityGroups);
        }
    }, [allResponsibilityGroups]);

    useEffect(() => {
        if (allResponsibilityCenters && reportName === REPORT_NAME.RESPONSIBILITY_CENTER) {
            buildResponsibilityCentersDatasource(allResponsibilityCenters);
        }
    }, [allResponsibilityCenters]);



    const handleSearch = (event: any) => {
        if (reportName === REPORT_NAME.AGENT_MASTER) {
            getAllAgentMasterWithSearch({
                token: localUserObj?.token,
                payload: { offset: 1000, pageNumber: 0, searchBy: event.target.value },
            });
        } else if (reportName === REPORT_NAME.VALUE_CHAIN) {
            getAllValueChainWithSearch({
                token: localUserObj?.token,
                payload: { offset: 1000, pageNumber: 0, searchBy: event.target.value },
            });
        } else if (reportName === REPORT_NAME.VALUE_CHAIN_CATEGORY) {
            getAllValueChainCategoryWithSearch({
                token: localUserObj?.token,
                payload: { offset: 1000, pageNumber: 0, searchBy: event.target.value },
            });
        } else if (reportName === REPORT_NAME.RESPONSIBILITY_CENTER) {
            getAllResponsibilityCentersWithSearch({
                token: localUserObj?.token,
                payload: { offset: 1000, pageNumber: 0, searchBy: event.target.value },
            });
        } else if (reportName === REPORT_NAME.RESPONSIBILITY_GROUP) {
            getAllResponsibilityGroupsWithSearch({
                token: localUserObj?.token,
                payload: { offset: 1000, pageNumber: 0, searchBy: event.target.value },
            });
        } 
        else if (reportName === REPORT_NAME.TOKEN_MECHANISM_MASTER) {
            getAllTokenMechanismMasterWithSearch({
                token: localUserObj?.token,
                payload: { offset: 1000, pageNumber: 0, searchBy: event.target.value },
            });
        }
    };

    useEffect(() => {
        if (allAgentMasterWithSearchResponse.isSuccess) {
            dispatch(setAgentMasterBySearch(allAgentMasterWithSearchResponse));
        } else if (allAgentMasterWithSearchResponse.isError) {
            let response: any = allAgentMasterWithSearchResponse.error;
            alertMessage(response, "error");
        }
    }, [allAgentMasterWithSearchResponse.isSuccess, allAgentMasterWithSearchResponse.isError]);


    useEffect(() => {
        if (allResponsibilityCentersWithSearchResponse.isSuccess) {
            dispatch(setAllResponsibilityCenterBySearch(allResponsibilityCentersWithSearchResponse));
        } else if (allResponsibilityCentersWithSearchResponse.isError) {
            let response: any = allResponsibilityCentersWithSearchResponse.error;
            alertMessage(response, "error");
        }
    }, [allResponsibilityCentersWithSearchResponse.isSuccess, allResponsibilityCentersWithSearchResponse.isError]);

    useEffect(() => {
        if (allResponsibilityGroupsWithSearchResponse.isSuccess) {
            dispatch(setAllResponsibilityGroupBySearch(allResponsibilityGroupsWithSearchResponse));
            // setDatasource(allResponsibilityGroupsWithSearchResponse.data.data);
        } else if (allResponsibilityGroupsWithSearchResponse.isError) {
            let response: any = allResponsibilityGroupsWithSearchResponse.error;
            alertMessage(response, "error");
        }
    }, [allResponsibilityGroupsWithSearchResponse.isSuccess, allResponsibilityGroupsWithSearchResponse.isError]);

    useEffect(() => {
        if (getAllValueChainWithSearchResponse.isSuccess) {
            dispatch(setAllValueChainsBySearch(getAllValueChainWithSearchResponse));
        } else if (getAllValueChainWithSearchResponse.isError) {
            let response: any = getAllValueChainWithSearchResponse.error;
            alertMessage(response, "error");
        }
    }, [getAllValueChainWithSearchResponse.isSuccess, getAllValueChainWithSearchResponse.isError]);

    useEffect(() => {
        if (getAllValueChainCategoryWithSearchResponse.isSuccess) {
            dispatch(setAllValueChainCategoriesBySearch(getAllValueChainCategoryWithSearchResponse));
        } else if (getAllValueChainCategoryWithSearchResponse.isError) {
            let response: any = getAllValueChainCategoryWithSearchResponse.error;
            alertMessage(response, "error");
        }
    }, [getAllValueChainCategoryWithSearchResponse.isSuccess, getAllValueChainCategoryWithSearchResponse.isError]);

    useEffect(() => {
        if (getAllTokenMechanismMasterWithSearchResponse.isSuccess) {
            dispatch(setTokenMechanismMastersBySearch
                (getAllTokenMechanismMasterWithSearchResponse));
        } else if (getAllTokenMechanismMasterWithSearchResponse.isError) {
            let response: any = getAllTokenMechanismMasterWithSearchResponse.error;
            alertMessage(response, "error");
        }
    }, [getAllTokenMechanismMasterWithSearchResponse.isSuccess, getAllTokenMechanismMasterWithSearchResponse.isError]);

    useEffect(() => {
        if (allOrganizationMasterBySearch && reportName === REPORT_NAME.ORGANIZATION_MASTER) {
            setDatasource(allOrganizationMasterBySearch);
        }
    }, [allOrganizationMasterBySearch]);

    useEffect(() => {
        if (allAgentMasterBySearch && reportName === REPORT_NAME.AGENT_MASTER) {
            setDatasource(allAgentMasterBySearch);
        }
    }, [allAgentMasterBySearch]);

    useEffect(() => {
        if (allValueChainsBySearch && reportName === REPORT_NAME.VALUE_CHAIN) {
            buildValueChainDataSource(allValueChainsBySearch);
        }
    }, [allValueChainsBySearch]);

    useEffect(() => {
        if (allValueChainCategoriesBySearch && reportName === REPORT_NAME.VALUE_CHAIN_CATEGORY) {
            buildValueChainCategoryDataSource(allValueChainCategoriesBySearch);
        }
    }, [allValueChainCategoriesBySearch]);

    useEffect(() => {
        if (allResponsibilityGroupsBySearch && reportName === REPORT_NAME.RESPONSIBILITY_GROUP) {
            setDatasource(allResponsibilityGroupsBySearch);
        }
    }, [allResponsibilityGroupsBySearch]);


    useEffect(() => {
        if (allResponsibilityGroupsBySearch && reportName === REPORT_NAME.RESPONSIBILITY_GROUP) {
            setDatasource(allResponsibilityGroupsBySearch);
        }
    }, [allResponsibilityGroupsBySearch]);

    useEffect(() => {
        if (allTokenMechanismMasterBySearch && reportName === REPORT_NAME.TOKEN_MECHANISM_MASTER) {
            buildTokenMechanismMasterDataSource(allTokenMechanismMasterBySearch);
        }
    }, [allTokenMechanismMasterBySearch]);


    useEffect(() => {
        if (allResponsibilityCentersBySearch && reportName === REPORT_NAME.RESPONSIBILITY_CENTER) {
            buildResponsibilityCentersDatasource(allResponsibilityCentersBySearch);
        }
    }, [allResponsibilityCentersBySearch]);


    return (
        <div className="mt-2 overflow-y-auto">
            <div className="d-flex align-items-center justify-content-between flex-sm-row flex-column mb-2">
                <div className="d-flex align-items-center w-100 px-2">
                    <h5
                        className="m-0 px-0 d-flex align-items-center text-accent"
                        style={{ fontWeight: "700" }}
                    >
                        {reportName}
                    </h5>
                </div>
                <div className="d-flex align-items-center justify-content-start justify-content-sm-end cursor-pointer w-100">
                    <div className="d-flex flex-column">
                        <div className="input-group px-2 mt-1">
                            <Form.Control
                                type="search"
                                placeholder="Search"
                                className="border-0 bg-cm-light-primary1"
                                aria-label="Search"
                                onChange={handleSearch}
                            />
                            <div className="input-group-append bg-cm-light-primary1 p-1 rounded-end">
                                <span className="input-group-text bg-cm-light-primary1 border-0">
                                    {/* <img src={gear} alt="" /> */}
                                    <BsSearch className=" bg-cm-light-primary1 border-cm-light-primary1" />
                                </span>
                            </div>
                        </div>
                    </div>

                    <div className="d-flex px-2 align-items-center mt-1">
                        <Button
                            // variant="primary"
                            className="d-flex align-items-center me-0 text-nowrap bg-accent"
                            onClick={handleShow}
                        >
                            <BsPlus />
                            Add
                        </Button>
                    </div>
                    {allAgentMasterResponseWithPagination.isLoading ||
                        valueChainCategoriesWithPaginationResponse.isLoading ||
                        valueChainCategoriesWithPaginationResponse.isLoading ||
                        responsibilityCenterResponse.isLoading ||
                        responsibilityGroupResponse.isLoading ||
                        allAgentMasterWithSearchResponse.isLoading ||
                        allResponsibilityCentersWithSearchResponse.isLoading ||
                        allResponsibilityGroupsWithSearchResponse.isLoading ||
                        getAllValueChainWithSearchResponse.isLoading ||
                        getAllValueChainCategoryWithSearchResponse.isLoading ||
                        valueChainsResponse.isLoading ||
                        deleteAgentMasterByIdResponse.isLoading ||
                        deleteValueChainCategoryByIdResponse.isLoading ||
                        deleteValueChainByIdResponse.isLoading ||
                        deleteResponsibilityCenterResponse.isLoading ||
                        deleteResponsibilityGroupResponse.isLoading ||
                        allOrganizationMasterResponse.isLoading ||
                        deleteOrganizationMasterResponse.isLoading ||
                        allTokenMechanismMasterResponse.isLoading ||
                        getAllTokenMechanismMasterWithSearchResponse.isLoading ||
                        deleteTokenMechanismMasterResponse.isLoading
                        ? (
                            <Loading />
                        ) : (
                            ""
                        )}
                    {show && (
                        <MasterReportData
                            show={show}
                            setShow={setShow}
                            actionType={actionType}
                            reportName={reportName}
                            data={selectedRow}
                            setCall={setCall}
                            isCategory={isCategory}
                            setIsCategory={setIsCategory}
                        />
                    )}
                </div>
            </div>
            <div className="mt-3 my-2 w-100 overflow-x-auto rounded-3">
                <Table
                    bordered={true}
                    rowKey={"id"}
                    scroll={{ x: 'max-content' }}
                    tableLayout="fixed"
                    pagination={{
                        total: (() => {
                            switch (reportName) {
                                case REPORT_NAME.AGENT_MASTER:
                                    return totalAgentMaster;
                                case REPORT_NAME.VALUE_CHAIN_CATEGORY:
                                    return totalValueChainCategory;
                                case REPORT_NAME.VALUE_CHAIN:
                                    return totalValueChain;
                                case REPORT_NAME.RESPONSIBILITY_CENTER:
                                    return totalResponsibilityCenters;
                                case REPORT_NAME.RESPONSIBILITY_GROUP:
                                    return totalResponsibilityGroups;
                                case REPORT_NAME.ORGANIZATION_MASTER:
                                    return totalOrganizationMaster;
                                case REPORT_NAME.TOKEN_MECHANISM_MASTER:
                                    return totalTokenMechanismMaster;
                                default:
                                    return dataSource.length;
                            }
                        })(),
                        responsive: true,
                        current: currentpage,
                        // showSizeChanger: true,  
                        pageSizeOptions: [10, 20, 30],
                        onChange: (page, pageSize) => {
                            paginationChange(page, pageSize);
                        },
                        pageSize: pageSize,
                    }}
                    columns={columData}
                    dataSource={dataSource}
                />
            </div>
        </div>
    );
};
export default DataSourceMangement;